module.exports = __webpack_public_path__ + "static/media/dani_icon.abf9c563.svg";